import React from "react";
import DatePickerInner from "./DatePickerInner";
import moment from "moment";

export default class MyDatePickerBilling extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Valore interno: memorizziamo un Date o null
      value: null,
    };
  }

  componentDidMount() {
    this.setState({ value: this.parseValue(this.props.value) });
  }

  componentDidUpdate(prevProps) {
    // Se il parent cambia la prop value, ricalcoliamo
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.parseValue(this.props.value) });
    }
  }

  /**
   * Converte la stringa in un oggetto Date o null se non valido/vuoto.
   * Supponiamo che la stringa arrivata da props.value sia "YYYY-MM-DD"
   */
  parseValue(str) {
    if (!str) return null; // Se stringa vuota o undefined
    const d = new Date(str); // "2025-04-10" -> Date(2025, 3, 10)
    if (isNaN(d.getTime())) {
      return null; // Non è parseabile
    }
    return d;
  }

  /**
   * Ritorna la data come Date object
   */
  getDate() {
    return this.state.value; // Restituisco l’oggetto Date
  }

  /**
   * Quando l’utente cambia data nel DatePickerInner,
   * 'date' sarà un Date object o null.
   */
  handleChange(date) {
    this.setState({ value: date });
    if (this.props.onChange) {
      // Se vuoi restituire in formato YYYY-MM-DD:
      if (date) {
        this.props.onChange(moment(date).format("YYYY-MM-DD"));
      } else {
        this.props.onChange(""); // Se rimuove la data
      }
    }
  }

  render() {
    return (
      <div style={mainClass}>
        <div style={name}>{this.props.name}</div>
        <DatePickerInner
          readOnly={this.props.readOnly || false}
          style={inputText}
          selected={this.state.value}
          dateFormat={this.props.dateFormat || "dd-MM-yyyy"}
          onChange={(date) => this.handleChange(date)}
        />
      </div>
    );
  }
}

const mainClass = {
  padding: "5px",
};

const name = {};

const inputText = {
  width: "300px",
  padding: "10px",
};
